<script>
import axios from '@/utils/axios';
import { changeLeadStage } from '@/utils/lead';
import Permissions from '@/utils/permissions.js';
import { paymentGateway } from '@/utils/app-store';
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { createSiteInspection } from '@/utils/site-inspection';
import DocumentUploadModal from '@/components/modal/document-upload-modal.vue';
import LeadRequirementModal from '@/components/modal/lead-requirement-modal.vue';
import { useLeadMetaStore } from '@/stores/useLeadMetaStore'

export default {
inject: ['setLoading'],
components: {
  DocumentUploadModal,
  LeadRequirementModal,
}, 
 data() {
  return {
   editor: ClassicEditor,
   client_type: 'App\\Models\\Lead',
   editorData: " ",
   editorConfig: {},
   errors: {},
   lead: [],
  //  stages: [],
  //  sources: [],
   reminders: [],
   reminder_status: 'all',
   assignment_history: [],
   razorpay_status: '',
   permissions: Permissions,
   leadMetaStore: null, 
  }
 },

//  async mounted(){
//   const lead_id = this.$route.params.id;
//   this.loadAll(lead_id);
//   await Permissions.init();
//   this.paymentGatewayStatus();
//  },

async mounted(){
  const lead_id = this.$route.params.id;

  this.leadMetaStore = useLeadMetaStore()
  this.leadMetaStore.loadAll()

  this.loadAll(lead_id);
  await Permissions.init();
  this.paymentGatewayStatus();
},

 computed: {
  stages() { return this.leadMetaStore?.stages || [] },
  sources() { return this.leadMetaStore?.sources || [] },
},

 methods: {

  async deleteRequirement(id){
 const result = await this.$confirm({});
 if(result.isConfirmed){
  this.setLoading(true);
  try{
   const response = await axios.delete(`/lead-requirements/${id}`);
   this.$swalToast(response.data.message);
   this.leadById(this.lead.id);
  }catch(error){
   this.$swalToast(error.message, 'error');
  }finally{
   this.setLoading(false);
  }
 }
},

  async createSiteInspection() {
    this.setLoading(true)
    try {
        const res = await createSiteInspection({
            party_type: 'App\\Models\\Lead',
            party_id: this.lead.id
        })
        this.$swalToast(res.data.message)
    } catch (error) {
        if (error.type === 'validation') {
            const firstError = Object.values(error.errors)[0]
            this.$swalToast(firstError[0], 'error')
        } else {
            this.$swalToast(error.message, 'error')
        }
    } finally {
        this.setLoading(false)
    }
},

  async loadAll(lead_id){
   await this.leadById(lead_id); 
  //  await this.getStages();
  //  await this.getSources();
   await this.loadReminders();
  },

  async paymentGatewayStatus(){
   try{
    const data = await paymentGateway();
    this.razorpay_status = data.Razorpay;
   }catch(error){
    this.$swalToast(error.message, 'error');
   } 
  },

  // async getStages() {
  //  this.setLoading(true);
  //  try{
  //   const response = await axios.get('/lead-stages');
  //   this.stages = response.data.data;
  //  }catch(error){
  //   this.$swalToast(error.message, 'error');
  //  }finally{
  //   this.setLoading(false);
  //  }
  // },

  // async getSources() {
  //  this.setLoading(true);
  //  try{
  //    const response = await axios.get('/lead-sources');
  //    this.sources = response.data.data;
  //   }catch(error){
  //    this.$swalToast(error.message, 'error');
  //   }finally{
  //    this.setLoading(false);
  //   }
  // },

  async leadById(lead_id){
   this.setLoading(true);
   try{
    const response = await axios.get(`/leads/${lead_id}`);
    this.lead = response.data.data;
    if(this.lead === null){
     this.$router.push('/crm/leads-list');
    }
   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   }
  },

  async changeStage(lead_id, stage_id, show_reminder_popup, is_upload_document) {
  if (show_reminder_popup == 1) {
    // Reminder first, pass document flag
    this.$refs.reminderModal.addReminderWithStage(lead_id, stage_id, is_upload_document == 1);
  } else if (is_upload_document == 1) {
    // Only document upload needed
    this.openDocumentUploadModal(lead_id, stage_id);
  } else {
    // Direct stage change
    this.setLoading(true);
    try {
      const response = await changeLeadStage(lead_id, stage_id);
      this.$swalToast(response.data.message);
      this.leadById(lead_id);
    } catch (error) {
      this.$swalToast(error.message, 'error');
    } finally {
      this.setLoading(false);
    }
  }
},

openDocumentUploadModal(lead_id, stage_id) {
  this.$refs.documentUploadModal.open(lead_id, stage_id);
},

async onDocumentUploaded() {
  this.$swalToast('Stage updated successfully!');
  this.loadAll(this.lead.id);
},


  async loadAssignmentHistory(){
   this.setLoading(true);
   try{
    const response = await axios.get(`/leads/${this.lead.id}/assignment/history`);  
    this.assignment_history = response.data.data;
   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   } 
  },

  viewInquiryMessage(){
   const inquiry_for = this.lead?.inquiry_for || ''; 
   const subject = (this.lead?.subject) ? `<h3>Subject: ${this.lead?.subject}</h3>` : "";
   Swal.fire({
    title: "Message:",
    html: `${subject}</h3><h4>${inquiry_for}</h4> ${this.lead?.message ?? ''}`,
   });
  },

  async loadReminders(){
   this.setLoading(true);
   try{
    const params = {
     status: this.reminder_status 
    };
    const query_string = new URLSearchParams(params).toString();
    const response = await axios.get(`/reminders/lead/${this.lead?.id}?${query_string}`);
    this.reminders = response.data.data.data; 
   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   } 
  },

  async markAsCompleted(id){
   const result = await this.$confirm({});
   if(result.isConfirmed){ 
    this.setLoading(true);
    try{
     const response = await axios.patch(`/reminders/${id}/complete`);
     this.$swalToast(response.data.message);
     this.loadReminders();
    }catch(error){
     this.$swalToast(error.message, 'error');
    }finally{
     this.setLoading(false);
    }
   }
  },  

 },
}
</script>

<template>
<layout-header></layout-header>
<layout-sidebar></layout-sidebar>
 
<div class="page-wrapper ld-page-wrapper">
  <div class="ld-container content">
 
    <!-- Top Bar -->
    <div class="ld-topbar">
      <div class="ld-topbar-left">
        <router-link to="/crm/leads-list" class="ld-back-btn">
          <i class="ti ti-arrow-left"></i>
          <span>Back to leads</span>
        </router-link>
        <span class="ld-breadcrumb-sep">/</span>
        <span class="ld-breadcrumb-current">Lead Details</span>
      </div>
      <div class="ld-topbar-right">
        <div class="dropdown" v-if="!lead.converted_at">
          <button type="button" class="ld-stage-btn dropdown-toggle" data-bs-toggle="dropdown" :style="{ backgroundColor: lead.stage?.color || '#6c757d' }">
            <i class="ti ti-flag-3 me-1"></i>{{ lead.stage?.name }}
          </button>
          <ul class="dropdown-menu dropdown-menu-end">
            <template v-for="stage in stages" :key="stage.id">
              <li>
                <a class="dropdown-item" :class="{ 'active': stage.id === lead.stage?.id }" href="javascript:void(0);" @click="changeStage(lead.id, stage.id, stage.show_reminder_popup, stage.is_upload_document)">
                  <span class="ld-stage-dot" :style="{ backgroundColor: stage.color || '#6c757d' }"></span>
                  {{ stage.name }}
                  <i class="ti ti-check ms-auto" v-if="stage.id === lead.stage?.id"></i>
                </a>
              </li>
            </template>
          </ul>
        </div>
        <span v-else class="badge bg-success fs-12 px-3 py-2" v-html="$leadConversionLabel()"></span>
      </div>
    </div>
 
    <!-- Main Content -->
    <div class="ld-body">
 
      <!-- LEFT PANEL -->
      <div class="ld-left-panel">
 
        <!-- Profile Card -->
        <div class="ld-card ld-profile-card">
          <div class="ld-avatar-wrap">
            <span class="ld-avatar">
              <img src="@/assets/img/profiles/avatar-12.jpg" />
            </span>
            <span class="ld-online-dot" v-if="!lead.converted_at"></span>
          </div>
          <h4 class="ld-lead-name">{{ lead.name }}</h4>
          <p class="ld-lead-company" v-if="lead.company_name">
            <i class="ti ti-building me-1"></i>{{ lead.company_name }}
          </p>
          <p class="ld-lead-location" v-if="lead.city || lead.country">
            <i class="ti ti-map-pin me-1"></i>
            {{ [lead.city, lead.state, lead.country].filter(Boolean).join(', ') }}
            <span v-if="lead.pincode"> - {{ lead.pincode }}</span>
          </p>
 
          <!-- Quick Action Buttons -->
          <div class="ld-quick-actions" v-if="!lead.converted_at">
            <div class="dropdown">
              <button type="button" class="ld-create-btn dropdown-toggle" data-bs-toggle="dropdown">
                <i class="ti ti-plus me-1"></i> Create New
              </button>
              <ul class="dropdown-menu">
                <li v-if="permissions.isLoaded && permissions.canCreateProposal">
                  <a class="dropdown-item" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#proposal_modal" @click="$refs.proposalModal.createViaLead(lead.id)">
                    <i class="ti ti-file-text me-2 text-primary"></i>Proposal
                  </a>
                </li>
                <li v-if="permissions.isLoaded && permissions.canCreateQuotation">
                  <a class="dropdown-item" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#quotation_modal" @click="$refs.quotationModal.createViaParty(client_type, lead.id)">
                    <i class="ti ti-file-check me-2 text-success"></i>Quotation
                  </a>
                </li>
                <li v-if="permissions.isLoaded && permissions.canCreateProforma">
                  <a class="dropdown-item" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#proforma_invoice_modal" @click="$refs.proformaInvoiceModal.createViaParty(client_type, lead.id)">
                    <i class="ti ti-receipt-rupee me-2 text-warning"></i>Proforma Invoice
                  </a>
                </li>
                <li><hr class="dropdown-divider"></li>
                <li v-if="razorpay_status === 'Connected'">
                  <a class="dropdown-item" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#payment_link_modal" @click="$refs.paymentLinkModal.createViaParty(client_type, lead.id)">
                    <i class="ti ti-link me-2 text-info"></i>Payment Link
                  </a>
                </li>
                <li v-if="permissions.isLoaded && permissions.canCreateSampling">
                  <a class="dropdown-item" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#sampling_modal" @click="$refs.samplingModal.createViaParty(client_type, lead.id)">
                    <i class="ti ti-cube-send me-2 text-secondary"></i>Sampling Request
                  </a>
                </li>
                <li v-if="permissions.isLoaded && permissions.canCreateSalesOrder">
                  <a class="dropdown-item" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#sales_order_modal" @click="$refs.salesOrderModal.createViaParty(client_type, lead.id)">
                    <i class="ti ti-shopping-cart me-2 text-danger"></i>Sales Order
                  </a>
                </li>
                <li>
                    <a class="dropdown-item" href="javascript:void(0);" @click="createSiteInspection">
                        <i class="ti ti-clipboard-check me-2 text-teal"></i>Site Inspection
                    </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
 
        <!-- Lead Information Card -->
        <div class="ld-card">
          <div class="ld-card-header">
            <span class="ld-section-title">Lead Information</span>
            <a href="javascript:void(0);" class="ld-edit-btn" data-bs-toggle="modal" data-bs-target="#lead_modal" @click="$refs.leadModal.editLead(lead)" v-if="!lead.converted_at">
              <i class="ti ti-edit"></i>
            </a>
          </div>
          <div class="ld-info-list">
            <div class="ld-info-row" v-if="lead.email">
              <span class="ld-info-label"><i class="ti ti-mail"></i> Email</span>
              <span class="ld-info-value">{{ lead.email }}</span>
            </div>
            <div class="ld-info-row">
              <span class="ld-info-label"><i class="ti ti-phone"></i> Phone</span>
              <span class="ld-info-value">{{ lead.mobile }}</span>
            </div>
            <div class="ld-info-row" v-if="lead.alt_mobile">
              <span class="ld-info-label"><i class="ti ti-phone"></i> Alt Phone</span>
              <span class="ld-info-value">{{ lead.alt_mobile }}</span>
            </div>
            <div class="ld-info-row">
              <span class="ld-info-label"><i class="ti ti-database-share"></i> Source</span>
              <span class="ld-info-value">
                <span class="ld-badge ld-badge-green">
                  <a :href="lead?.source_url" target="_blank" v-if="lead?.source_url"><i class="ti ti-link me-1"></i></a>
                  {{ lead.source?.name }}
                </span>
              </span>
            </div>
            <div class="ld-info-row" v-if="lead?.type">
              <span class="ld-info-label"><i class="ti ti-sparkles"></i> Type</span>
              <span class="ld-info-value">
                <span class="ld-badge ld-badge-blue">{{ lead?.type }}</span>
              </span>
            </div>
            <div class="ld-info-row" v-if="lead?.message || lead?.inquiry_for">
              <span class="ld-info-label"><i class="ti ti-message"></i> Inquiry</span>
              <span class="ld-info-value">
                <button type="button" class="ld-view-msg-btn" @click="viewInquiryMessage">
                  <i class="ti ti-info-circle me-1"></i>View Message
                </button>
              </span>
            </div>
            <div class="ld-info-row" v-if="lead.designation">
              <span class="ld-info-label"><i class="ti ti-user-star"></i> Designation</span>
              <span class="ld-info-value">{{ lead?.designation }}</span>
            </div>
            <div class="ld-info-row">
              <span class="ld-info-label"><i class="ti ti-calendar"></i> Created</span>
              <span class="ld-info-value">{{ $formatDate(lead.created_at, 'DD MMM YYYY, hh:mm a') }}</span>
            </div>
          </div>
        </div>
 
        <!-- Assigned Card -->
        <div class="ld-card">
          <div class="ld-card-header">
            <span class="ld-section-title">Assigned To</span>
            <a href="javascript:void(0);" class="ld-edit-btn" data-bs-toggle="modal" data-bs-target="#assign_lead_modal" @click="$refs.leadModal.editLead(lead)" v-if="!lead.converted_at">
              <i class="ti ti-edit"></i>
            </a>
          </div>
          <div class="ld-assigned-row">
<span class="ld-user-avatar">
  <img v-if="lead.user?.image" :src="lead.user?.image_url" width="32" />
  <img v-else src="@/assets/img/profiles/avatar-12.jpg" width="32" />
</span>
            <div>
              <p class="ld-user-name">{{ lead.user?.name }}</p>
              <p class="ld-user-role">Lead Owner</p>
            </div>
          </div>
        </div>
 
        <!-- Other Information Card -->
        <div class="ld-card">
          <div class="ld-card-header">
            <span class="ld-section-title">Other Information</span>
          </div>
          <div class="ld-info-list">
            <div class="ld-info-row">
              <span class="ld-info-label"><i class="ti ti-user-check"></i> Created By</span>
              <span class="ld-info-value ld-flex-center">
<span class="ld-user-avatar ld-user-avatar-sm me-1">
  <img v-if="lead.created_by?.image" :src="lead.created_by?.image_url" width="20" />
  <img v-else src="@/assets/img/profiles/avatar-12.jpg" width="20" />
</span>
                {{ lead.created_by?.name }}
              </span>
            </div>
            <div class="ld-info-row">
              <span class="ld-info-label"><i class="ti ti-calendar-check"></i> Last Modified</span>
              <span class="ld-info-value">{{ $formatDate(lead.updated_at, 'DD MMM YYYY, hh:mm a') }}</span>
            </div>
          </div>
        </div>
 
      </div>
      <!-- /LEFT PANEL -->
 
      <!-- RIGHT PANEL -->
      <div class="ld-right-panel">
 
        <!-- Tabs -->
        <div class="ld-tabs-card">
          <ul class="ld-tabs" role="tablist">
            <li role="presentation">
              <a class="ld-tab active" href="#bottom-justified-tab1" data-bs-toggle="tab" role="tab">
                <i class="ti ti-activity"></i> Activities
              </a>
            </li>
            <li role="presentation">
              <a class="ld-tab" href="#bottom-justified-tab2" data-bs-toggle="tab" role="tab">
                <i class="ti ti-file-description"></i> Notes
              </a>
            </li>
            <li role="presentation">
              <a class="ld-tab" href="#reminder-tab" data-bs-toggle="tab" role="tab" @click="loadReminders">
                <i class="ti ti-bell"></i> Reminders
              </a>
            </li>
            <li role="presentation">
              <a class="ld-tab" href="#assignment-history-tab" data-bs-toggle="tab" role="tab" @click="loadAssignmentHistory">
                <i class="ti ti-history"></i> History
              </a>
            </li>
            <li role="presentation">
            <a class="ld-tab" href="#documents-tab" data-bs-toggle="tab" role="tab">
              <i class="ti ti-file-upload"></i> Documents
            </a>
          </li>
          <li role="presentation">
          <a class="ld-tab" href="#requirements-tab" data-bs-toggle="tab" role="tab">
            <i class="ti ti-list-check"></i> Requirements
          </a>
          </li>

            <li role="presentation" v-if="permissions.isLoaded && permissions.canCreateSampling">
              <a class="ld-tab" href="#sampling-tab" data-bs-toggle="tab" role="tab">
                <i class="ti ti-cube-send"></i> Sampling
              </a>
            </li>
          </ul>
        </div>
 
        <!-- Tab Content -->
        <div class="tab-content">
 
          <!-- Activities -->
          <div class="tab-pane active show" id="bottom-justified-tab1" role="tabpanel">
            <div class="ld-card ld-tab-content-card">
              <div class="ld-tab-header">
                <h6 class="ld-tab-title"><i class="ti ti-activity me-2"></i>Stage Activities</h6>
              </div>
              <div class="ld-tab-body">
                <template v-if="lead.activities?.length">
                  <div class="ld-activity-item" v-for="row in lead.activities" :key="row.id">
                    <div class="ld-activity-icon">
                      <i class="ti ti-activity"></i>
                    </div>
                    <div class="ld-activity-content">
                      <p class="ld-activity-desc">{{ row.description }}</p>
                      <span class="ld-activity-time"><i class="ti ti-clock me-1"></i>{{ $formatDate(row.created_at, 'DD MMM YYYY, hh:mm a') }}</span>
                    </div>
                  </div>
                </template>
                <div v-else class="ld-empty-state">
                  <i class="ti ti-mood-empty"></i>
                  <p>No activities yet</p>
                </div>
              </div>
            </div>
          </div>
 
          <!-- Notes -->
          <div class="tab-pane" id="bottom-justified-tab2" role="tabpanel">
            <div class="ld-card ld-tab-content-card">
              <div class="ld-tab-header">
                <h6 class="ld-tab-title"><i class="ti ti-file-description me-2"></i>Notes</h6>
                <a href="javascript:void(0);" class="ld-add-btn" data-bs-toggle="modal" data-bs-target="#notes_modal" @click="$refs.notesModal.addNote(lead);" v-if="!lead.converted_at">
                  <i class="ti ti-circle-plus me-1"></i> Add Note
                </a>
              </div>
              <div class="ld-tab-body">
                <template v-if="lead.comments?.length">
                  <div class="ld-note-item" v-for="row in lead.comments">
                    <div class="ld-note-header">
                      <div class="ld-flex-center">
                        <span class="ld-user-avatar ld-user-avatar-sm me-2">
                          <img v-if="row.user?.image" :src="row.user?.image_url" width="28" />
                          <img v-else src="@/assets/img/profiles/avatar-12.jpg" width="28" />
                        </span>
                        <span class="ld-note-author">{{ row.user?.name }}</span>
                      </div>
                      <span class="ld-note-time"><i class="ti ti-clock-hour-9 me-1"></i>{{ $formatDate(row.created_at, 'DD MMM YYYY, hh:mm a') }}</span>
                    </div>
                    <div class="ld-note-body" v-html="row.description"></div>
                  </div>
                </template>
                <div v-else class="ld-empty-state">
                  <i class="ti ti-notes"></i>
                  <p>No notes added yet</p>
                </div>
              </div>
            </div>
          </div>
 
          <!-- Reminders -->
          <div class="tab-pane" id="reminder-tab" role="tabpanel">
            <div class="ld-card ld-tab-content-card">
              <div class="ld-tab-header">
                <h6 class="ld-tab-title"><i class="ti ti-bell me-2"></i>Reminders</h6>
                <div class="ld-flex-center gap-2">
                  <select class="ld-select" v-model="reminder_status" @change="loadReminders">
                    <option value="all">All</option>
                    <option value="due">Due</option>
                    <option value="pending">Pending</option>
                    <option value="upcoming">Upcoming</option>
                    <option value="completed">Completed</option>
                  </select>
                  <a href="javascript:void(0);" class="ld-add-btn" data-bs-toggle="modal" data-bs-target="#reminder_modal" @click="$refs.reminderModal.addReminder(lead.id);" v-if="!lead.converted_at">
                    <i class="ti ti-circle-plus me-1"></i> Add Reminder
                  </a>
                </div>
              </div>
              <div class="ld-tab-body">
                <template v-if="reminders?.length">
                  <div class="ld-reminder-item" v-for="(row, index) in reminders" :key="index">
                    <div class="ld-reminder-left">
                      <div class="form-check form-check-md">
                        <input class="form-check-input" type="checkbox">
                      </div>
                      <div class="ld-reminder-info">
                        <a class="ld-reminder-title" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#reminder_view_modal" @click="$refs.reminderModal.editReminder(row)">
                          {{ row.title }}
                        </a>
                        <span class="ld-reminder-date"><i class="ti ti-calendar me-1"></i>{{ $formatDate(row.reminder_datetime, 'DD MMM YYYY, h:mm a') }}</span>
                      </div>
                    </div>
                    <div class="ld-reminder-right">
                      <span class="ld-badge ld-badge-green" v-if="row.is_completed"><i class="ti ti-circle-check me-1"></i>Completed</span>
                      <span class="ld-badge ld-badge-dark">{{ row.status }}</span>
                      <span class="ld-badge ld-badge-pink">{{ row.reminder_type }}</span>
                      <div class="dropdown">
                        <a href="javascript:void(0);" class="ld-dots-btn" data-bs-toggle="dropdown"><i class="ti ti-dots-vertical"></i></a>
                        <ul class="dropdown-menu dropdown-menu-end p-2">
                          <li v-if="!row.is_notified">
                            <a href="javascript:void(0);" class="dropdown-item rounded-1" data-bs-toggle="modal" data-bs-target="#reminder_modal" @click="$refs.reminderModal.editReminder(row)">
                              <i class="ti ti-edit me-2"></i>Edit
                            </a>
                          </li>
                          <li v-if="!row.is_completed">
                            <a href="javascript:void(0);" class="dropdown-item rounded-1" @click="markAsCompleted(row.id)">
                              <i class="ti ti-progress-check me-2"></i>Mark as completed
                            </a>
                          </li>
                          <li>
                            <a href="javascript:void(0);" class="dropdown-item rounded-1 text-danger" data-bs-toggle="modal" data-bs-target="#reminder_delete_modal" @click="$refs.reminderModal.editReminder(row)">
                              <i class="ti ti-trash me-2"></i>Delete
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </template>
                <div v-else class="ld-empty-state">
                  <i class="ti ti-bell-off"></i>
                  <p>No reminders found</p>
                </div>
              </div>
            </div>
          </div>
 
          <!-- History -->
          <div class="tab-pane" id="assignment-history-tab" role="tabpanel">
            <div class="ld-card ld-tab-content-card">
              <div class="ld-tab-header">
                <h6 class="ld-tab-title"><i class="ti ti-history me-2"></i>Assignment History</h6>
              </div>
              <div class="ld-tab-body">
                <div class="ld-table-wrap" v-if="assignment_history.length">
                  <table class="ld-table table-responsive">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Assigned By</th>
                        <th>Assigned From</th>
                        <th>Assigned To</th>
                        <th>Stage</th>
                        <th>Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, index) in assignment_history" :key="row.id">
                        <td>{{ index + 1 }}</td>
                        <td>{{ row.assign_by.name }}</td>
                        <td>{{ row.assign_from.name }}</td>
                        <td>{{ row.assign_to.name }}</td>
                        <td><span class="ld-badge ld-badge-blue">{{ row.stage }}</span></td>
                        <td>{{ $formatDate(row.created_at, 'DD-MM-YY, hh:mm a') }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-else class="ld-empty-state">
                  <i class="ti ti-history"></i>
                  <p>No history found</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Documents -->
        <div class="tab-pane" id="documents-tab" role="tabpanel">
          <div class="ld-card ld-tab-content-card">
            <div class="ld-tab-header">
              <h6 class="ld-tab-title"><i class="ti ti-file-upload me-2"></i>Documents</h6>
            </div>
            <div class="ld-tab-body">
              <div class="ld-table-wrap" v-if="lead?.documents?.length">
                <table class="ld-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Name</th>
                      <th>Type</th>
                      <th>Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in lead?.documents" :key="row.id">
                      <td>{{ index + 1 }}</td>
                      <td>{{ row.name || 'Untitled' }}</td>
                      <td><span class="ld-badge ld-badge-blue">{{ row.type }}</span></td>
                      <td>{{ $formatDate(row.created_at, 'DD MMM YYYY, hh:mm a') }}</td>
                      <td>
                        <a :href="row.document_url" target="_blank" class="" title="View">
                        View Document
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-else class="ld-empty-state">
                <i class="ti ti-file-off"></i>
                <p>No documents uploaded yet</p>
              </div>
            </div>
          </div>
        </div>


        <!-- Requirements -->
        <div class="tab-pane" id="requirements-tab" role="tabpanel">
          <div class="ld-card ld-tab-content-card">
            <div class="ld-tab-header">
              <h6 class="ld-tab-title"><i class="ti ti-list-check me-2"></i>Requirements</h6>
              <a href="javascript:void(0);" class="ld-add-btn" data-bs-toggle="modal" data-bs-target="#lead_requirement_modal" @click="$refs.requirementModal.addRequirement(lead.id)" v-if="!lead.converted_at">
                <i class="ti ti-circle-plus me-1"></i> Add Requirement
              </a>
            </div>
            <div class="ld-tab-body">
              <div class="ld-table-wrap" v-if="lead?.requirements?.length">
                <table class="ld-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Item</th>
                      <th>Brand</th>
                      <th>Description</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in lead?.requirements" :key="row.id">
                      <td>{{ index + 1 }}</td>
                      <td>
                        <div class="ld-flex-center">
                          {{ row.item?.name }}
                          <span class="ld-badge ld-badge-dark ms-2">{{ row.item?.code }}</span>
                        </div>
                      </td>
                      <td>{{ row.item?.brand?.name || '-' }}</td>
                      <td>{{ row.description || '-' }}</td>
                      <td>
                        <a href="javascript:void(0);" class="me-2" title="Edit" data-bs-toggle="modal" data-bs-target="#lead_requirement_modal" @click="$refs.requirementModal.editRequirement(row, lead.id)">
                          <i class="ti ti-edit"></i>
                        </a>
                        <a href="javascript:void(0);" class="text-danger" title="Delete" @click="deleteRequirement(row.id)">
                          <i class="ti ti-trash"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-else class="ld-empty-state">
                <i class="ti ti-list-check"></i>
                <p>No requirements added yet</p>
              </div>
            </div>
          </div>
        </div>
 
          <!-- Sampling -->
          <div class="tab-pane" id="sampling-tab" role="tabpanel">
            <div class="ld-card ld-tab-content-card">
              <div class="ld-tab-header">
                <h6 class="ld-tab-title"><i class="ti ti-cube-send me-2"></i>Sampling Requests</h6>
              </div>
              <div class="ld-tab-body">
                <div class="ld-table-wrap" v-if="lead?.samplings?.length">
                  <table class="ld-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Request No</th>
                        <th>Status</th>
                        <th>Assigned To</th>
                        <th>Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, index) in lead?.samplings" :key="row.id">
                        <td>{{ index + 1 }}</td>
                        <td>
                          <a href="javascript:void(0);" class="ld-link-primary" data-bs-toggle="modal" data-bs-target="#sampling_detail_modal" @click="$refs.samplingModal.sampling(row);">
                            {{ row.request_number }}
                          </a>
                        </td>
                        <td>
                          <span :class="['ld-badge', 
                            row?.status === 'pending' ? 'ld-badge-yellow' : '',
                            row?.status === 'dispatched' ? 'ld-badge-blue' : '', 
                            row?.status === 'delivered' ? 'ld-badge-green' : '']">
                            {{ row?.status }}
                          </span>
                        </td>
                        <td class="ld-flex-center">
                          <img :src="$profileImage(row.user.image, clientAdmin)" width="22" class="ld-user-avatar-sm me-1" />
                          {{ row.user.name }}
                        </td>
                        <td>{{ $formatDate(row.created_at, 'DD-MM-YY, hh:mm a') }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-else class="ld-empty-state">
                  <i class="ti ti-cube-off"></i>
                  <p>No sampling requests found</p>
                </div>
              </div>
            </div>
          </div>
 
        </div>
        <!-- /Tab Content -->
      </div>
      <!-- /RIGHT PANEL -->
 
    </div>
  </div>
  <app-footer></app-footer>
</div>
 
<!-- Modals (unchanged) -->
<leads-modal :stages="stages" :sources="sources" ref="leadModal" @updated="leadById(lead.id);"></leads-modal>
<notes-modal :stages="stages" :sources="sources" ref="notesModal" @updated="leadById(lead.id);"></notes-modal>
<reminder-modal ref="reminderModal" @updated="loadAll(lead.id)" @open-document-modal="openDocumentUploadModal"></reminder-modal>
<document-upload-modal ref="documentUploadModal" @uploaded="onDocumentUploaded"></document-upload-modal>
<sampling-modal ref="samplingModal"></sampling-modal>
<proposal-modal ref="proposalModal"></proposal-modal>
<quotation-modal ref="quotationModal"></quotation-modal>
<payment-link-modal ref="paymentLinkModal"></payment-link-modal>
<proforma-invoice-modal ref="proformaInvoiceModal"></proforma-invoice-modal>
<sales-order-modal ref="salesOrderModal" @updated="leadById(lead.id)"></sales-order-modal>
<lead-requirement-modal ref="requirementModal" @updated="leadById(lead.id)"></lead-requirement-modal>
 
</template>
 
<style scoped>
/* ============================================================
   LEAD DETAILS — HubSpot-inspired redesign
   Prefix: ld- (lead-details)
   ============================================================ */
 
/* Page wrapper — do NOT override background; let the global layout handle it */
.ld-page-wrapper {
  /* inherits page-wrapper styles from global layout */
}

 
/* ---- TOP BAR ---- */
.ld-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
 
.ld-topbar-left {
  display: flex;
  align-items: center;
  gap: 8px;
}
 
.ld-back-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  text-decoration: none;
  padding: 6px 12px;
  border-radius: 6px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  transition: all 0.15s;
}
.ld-back-btn:hover {
  background: #f9fafb;
  color: #111827;
}
 
.ld-breadcrumb-sep {
  color: #9ca3af;
  font-size: 13px;
}
.ld-breadcrumb-current {
  font-size: 13px;
  color: #6b7280;
}
 
.ld-stage-btn {
  display: inline-flex;
  align-items: center;
  border: none;
  border-radius: 6px;
  padding: 5px 12px;
  font-size: 12px;
  font-weight: 600;
  color: #fff !important;
  letter-spacing: 0.3px;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12);
  transition: opacity 0.15s;
  min-width: fit-content;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ld-stage-btn:hover { opacity: 0.88; }
 
.ld-stage-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 8px;
  flex-shrink: 0;
}
 
/* Stage dropdown menu — compact */
.ld-topbar-right .dropdown-menu {
  min-width: 180px;
  max-height: 320px;
  overflow-y: auto;
  font-size: 13px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 4px 16px rgba(0,0,0,0.1);
  padding: 6px;
}
.ld-topbar-right .dropdown-item {
  border-radius: 6px;
  padding: 7px 12px;
  font-size: 13px;
  display: flex;
  align-items: center;
}
.ld-topbar-right .dropdown-item.active {
  background: #fff7ed;
  color: #f97316;
  font-weight: 600;
}
 
/* ---- BODY LAYOUT ---- */
.ld-body {
  display: grid;
  grid-template-columns: 320px 1fr;
  gap: 20px;
  align-items: start;
}
 
/* ---- CARDS ---- */
.ld-card {
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  margin-bottom: 16px;
  overflow: visible;
  box-shadow: 0 1px 3px rgba(0,0,0,0.04);
}
 
.ld-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px 10px;
  border-bottom: 1px solid #f3f4f6;
}
 
.ld-section-title {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: #6b7280;
}
 
.ld-edit-btn {
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  color: #6b7280;
  border: 1px solid #e5e7eb;
  font-size: 13px;
  transition: all 0.15s;
}
.ld-edit-btn:hover {
  background: #f3f4f6;
  color: #374151;
}
 
/* ---- PROFILE CARD ---- */
.ld-profile-card {
  text-align: center;
  padding: 28px 20px 20px;
}
 
.ld-avatar-wrap {
  position: relative;
  display: inline-block;
  margin-bottom: 14px;
}
.ld-avatar {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  overflow: hidden;
  border: 3px solid #fff;
  box-shadow: 0 2px 10px rgba(0,0,0,0.12);
  display: block;
}
.ld-avatar img { width: 100%; height: 100%; object-fit: cover; }
 
.ld-online-dot {
  position: absolute;
  bottom: 3px;
  right: 3px;
  width: 12px;
  height: 12px;
  background: #22c55e;
  border-radius: 50%;
  border: 2px solid #fff;
}
 
.ld-lead-name {
  font-size: 16px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 4px;
}
 
.ld-lead-company {
  font-size: 13px;
  color: #6b7280;
  margin-bottom: 4px;
}
 
.ld-lead-location {
  font-size: 12px;
  color: #9ca3af;
  margin-bottom: 0;
}
 
/* ---- Quick Actions ---- */
.ld-quick-actions {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #f3f4f6;
  position: relative;
  z-index: 100;
}
 
.ld-create-btn {
  display: inline-flex;
  align-items: center;
  padding: 8px 20px;
  border-radius: 8px;
  background: #f97316;
  color: #fff !important;
  font-size: 13px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: background 0.15s;
  width: 100%;
  justify-content: center;
}
.ld-create-btn:hover { background: #ea6c0a; color: #fff !important; }
/* Force Bootstrap dropdown to be visible above card overflow:hidden */
.ld-quick-actions .dropdown-menu {
  z-index: 9999 !important;
  font-size: 13px;
  min-width: 200px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.12);
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 6px;
}
.ld-quick-actions .dropdown-item {
  border-radius: 6px;
  padding: 7px 12px;
  font-size: 13px;
}
 
/* ---- INFO LIST ---- */
.ld-info-list {
  padding: 8px 0;
}
 
.ld-info-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 9px 18px;
  gap: 8px;
  border-bottom: 1px solid #f9fafb;
}
.ld-info-row:last-child { border-bottom: none; }
 
.ld-info-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #9ca3af;
  font-weight: 500;
  min-width: 100px;
  white-space: nowrap;
}
.ld-info-label i { font-size: 13px; }
 
.ld-info-value {
  font-size: 13px;
  color: #374151;
  font-weight: 500;
  text-align: right;
  word-break: break-all;
}
 
/* ---- BADGES ---- */
.ld-badge {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.2px;
}
.ld-badge-green { background: #dcfce7; color: #15803d; }
.ld-badge-blue  { background: #dbeafe; color: #1d4ed8; }
.ld-badge-pink  { background: #fce7f3; color: #be185d; }
.ld-badge-yellow{ background: #fef9c3; color: #854d0e; }
.ld-badge-dark  { background: #f3f4f6; color: #374151; }
 
/* ---- VIEW MSG BTN ---- */
.ld-view-msg-btn {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  background: #f9fafb;
  font-size: 12px;
  color: #374151;
  cursor: pointer;
  transition: all 0.15s;
}
.ld-view-msg-btn:hover { background: #f3f4f6; }
 
/* ---- ASSIGNED ROW ---- */
.ld-assigned-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 18px;
}
 
.ld-user-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  overflow: hidden;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #f3f4f6;
  flex-shrink: 0;
}
.ld-user-avatar img { width: 100%; height: 100%; object-fit: cover; border-radius: 50%; }
.ld-user-avatar-sm { width: 26px; height: 26px; }
 
.ld-user-name {
  font-size: 13px;
  font-weight: 600;
  color: #111827;
  margin: 0;
}
.ld-user-role {
  font-size: 11px;
  color: #9ca3af;
  margin: 0;
}
 
/* ---- TABS ---- */
.ld-tabs-card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 4px 8px;
  margin-bottom: 16px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.04);
  display: flex;
  align-items: center;
}
 
.ld-tabs {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  gap: 2px;
}
 
.ld-tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  color: #6b7280;
  text-decoration: none;
  transition: all 0.15s;
  border-bottom: 2px solid transparent;
  white-space: nowrap;
}
.ld-tab:hover {
  color: #374151;
  background: #f9fafb;
}
.ld-tab.active,
.ld-tab[aria-selected="true"] {
  color: #f97316;
  font-weight: 600;
  border-bottom-color: #f97316;
  background: #fff7ed;
}
.ld-tab i { font-size: 14px; }
 
/* ---- TAB CONTENT CARDS ---- */
.ld-tab-content-card {
  margin-bottom: 0;
}
 
.ld-tab-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  border-bottom: 1px solid #f3f4f6;
  flex-wrap: wrap;
  gap: 10px;
}
 
.ld-tab-title {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  margin: 0;
}
 
.ld-tab-body {
  padding: 16px 20px;
}
 
.ld-add-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 600;
  color: #f97316;
  text-decoration: none;
  padding: 5px 12px;
  border-radius: 6px;
  border: 1px solid #fed7aa;
  background: #fff7ed;
  transition: all 0.15s;
}
.ld-add-btn:hover { background: #ffedd5; color: #ea6c0a; }
 
/* ---- ACTIVITY ---- */
.ld-activity-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid #f9fafb;
}
.ld-activity-item:last-child { border-bottom: none; }
 
.ld-activity-icon {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  background: #e0f2fe;
  color: #0284c7;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  flex-shrink: 0;
}
 
.ld-activity-desc {
  font-size: 13px;
  color: #374151;
  font-weight: 500;
  margin-bottom: 4px;
}
.ld-activity-time {
  font-size: 11px;
  color: #9ca3af;
  display: flex;
  align-items: center;
}
 
/* ---- NOTES ---- */
.ld-note-item {
  border: 1px solid #f3f4f6;
  border-radius: 8px;
  padding: 14px 16px;
  margin-bottom: 12px;
  background: #fafafa;
}
.ld-note-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  flex-wrap: wrap;
  gap: 6px;
}
.ld-note-author {
  font-size: 13px;
  font-weight: 600;
  color: #111827;
}
.ld-note-time {
  font-size: 11px;
  color: #9ca3af;
  display: flex;
  align-items: center;
}
.ld-note-body {
  font-size: 13px;
  color: #374151;
  line-height: 1.6;
}
 
/* ---- REMINDERS ---- */
.ld-select {
  padding: 5px 10px;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  font-size: 12px;
  color: #374151;
  background: #fff;
  outline: none;
}
 
.ld-reminder-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #f9fafb;
  flex-wrap: wrap;
  gap: 10px;
}
.ld-reminder-item:last-child { border-bottom: none; }
 
.ld-reminder-left {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  min-width: 0;
}
 
.ld-reminder-info {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
 
.ld-reminder-title {
  font-size: 13px;
  font-weight: 600;
  color: #111827;
  text-decoration: none;
}
.ld-reminder-title:hover { color: #f97316; }
 
.ld-reminder-date {
  font-size: 11px;
  color: #9ca3af;
  display: flex;
  align-items: center;
}
 
.ld-reminder-right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
 
.ld-dots-btn {
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  color: #9ca3af;
  transition: all 0.15s;
}
.ld-dots-btn:hover { background: #f3f4f6; color: #374151; }
 
/* ---- TABLE ---- */
.ld-table-wrap {
  overflow-x: auto;
}
 
.ld-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
 
.ld-table thead tr {
  background: #f9fafb;
}
 
.ld-table th {
  padding: 10px 14px;
  text-align: left;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #9ca3af;
  border-bottom: 1px solid #f3f4f6;
  white-space: nowrap;
}
 
.ld-table td {
  padding: 12px 14px;
  color: #374151;
  border-bottom: 1px solid #f9fafb;
  vertical-align: middle;
  white-space: nowrap;
}
 
.ld-table tbody tr:last-child td { border-bottom: none; }
 
.ld-table tbody tr:hover { background: #fafafa; }
 
.ld-link-primary {
  color: #f97316;
  font-weight: 600;
  text-decoration: none;
}
.ld-link-primary:hover { text-decoration: underline; }
 
/* ---- EMPTY STATE ---- */
.ld-empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #d1d5db;
}
.ld-empty-state i {
  font-size: 36px;
  display: block;
  margin-bottom: 8px;
}
.ld-empty-state p {
  font-size: 13px;
  color: #9ca3af;
  margin: 0;
}
 
/* ---- UTILS ---- */
.ld-flex-center {
  display: flex;
  align-items: center;
}
 
.gap-2 { gap: 8px; }
.me-1 { margin-right: 4px; }
.me-2 { margin-right: 8px; }
 
/* ---- RESPONSIVE ---- */
@media (max-width: 1024px) {
  .ld-body {
    grid-template-columns: 1fr;
  }
  .ld-left-panel {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }
}
 
@media only screen and (max-width: 767px) {
  .ld-container { padding: 16px; }
  .ld-left-panel {
    grid-template-columns: 1fr;
  }
  .ld-tabs { gap: 0; }
  .ld-tab { padding: 8px 10px; font-size: 12px; }
  .ld-right-panel{
    overflow: hidden;
  }
  .ld-tabs-card{
    overflow-x: scroll;
  }
}
</style>